import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

export const useSettings = () => {
    return useSelector(getSettingsCollection);
};

export const useProductSettings = () => {
    return useSelector(getSettingsCollection).productSettings;
};
